<template>
    <div>

        <PageHeader>
            <template v-if="product">{{ product.name }}</template>
            <template #side>
                <ButtonIcon :to="parentRoute">
                    {{ $t('goBack') }}
                </ButtonIcon>
            </template>
        </PageHeader>

        <Details />

        <Offers plugin-offers="in" />

        <Offers plugin-offers="notIn" />

        <Logs />

        <ModalEdit />

    </div>
</template>



<script>
    import Details from './parts/Details.vue';
    import Offers from './parts/Offers.vue';
    import Logs from './parts/Logs.vue';
    import ModalEdit from './parts/ModalEdit.vue';

    export default {
        name: 'Product',
        components: {
            Details,
            Offers,
            Logs,
            ModalEdit,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                requestProduct: this.$req('producerProduct/product'),
                requestOffers: this.$req('producerProduct/offers'),
                requestLogs: this.$req('producerProduct/logs'),
                id: Number.parseInt(this.$route.params.id),
            };
        },
        computed: {
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-2)[0];
            },
            product() {
                return this.requestProduct.getData();
            },
        },
    };
</script>

